import { QueryClient } from '@tanstack/react-query';

/**
 * Global React Query defaults (Home + future SWR-style screens).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 45_000,
      gcTime: 6 * 60_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});
